import * as yup from "yup";

import {
	IEditProposalGuaranteeData,
	ISimulateEditCancel,
	ISimulateEditLocator,
	ISimulateEditProposal,
	ISimulateEditProposalAddress,
	ISimulateEditProposalValues,
} from "../../../../shared/services/api/proposal/ProposalEditService";

export const formValidationSchema: yup.SchemaOf<ISimulateEditProposal> = yup.object().shape({
	termBegin: yup.string().required("Campo Obrigatório"),
	expiresAt: yup.string().required("Campo Obrigatório"),
	contractBegin: yup.string().required("Campo Obrigatório"),
	contractEnd: yup.string().required("Campo Obrigatório"),
	rentMonthsCount: yup.string().notRequired(),
	rentMonthsCountContract: yup.string().notRequired(),
});

export const formValidationSchemaValue: yup.SchemaOf<ISimulateEditProposalValues> = yup.object().shape({
	rentAmount: yup.string().required("Campo Obrigatório"),
	fee: yup.string().required("Campo Obrigatório"),
	assuranceMonthAmount: yup.string().required("Campo Obrigatório"),
	lmi: yup.string().required("Campo Obrigatório"),
	lmiAmount: yup.string().required("Campo Obrigatório"),
	planId: yup.string().notRequired(),
});

export const formValidationSchemaAddress: yup.SchemaOf<ISimulateEditProposalAddress> = yup.object().shape({
	addressCity: yup.string().required("Campo Obrigatório"),
	addressComplement: yup.string().notRequired(),
	addressDistrict: yup.string().required("Campo Obrigatório"),
	addressNumber: yup.string().required("Campo Obrigatório"),
	addressState: yup.string().required("Campo Obrigatório"),
	addressStreet: yup.string().required("Campo Obrigatório"),
	addressIBGE: yup
		.string()
		.notRequired()
		.matches(/^\d{7}$/, { message: "O código IBGE deve ter 7 dígitos", excludeEmptyString: true }),
	propertyFinally: yup.string().required("Campo Obrigatório").oneOf(["commercial", "residential"], "Tipo de locação inválido"),
});

export const formValidationSchemaLocator: yup.SchemaOf<ISimulateEditLocator> = yup.object().shape({
	lessorName: yup.string().required("Campo Obrigatório"),
	lessorCpf: yup.string().required("Campo Obrigatório"),
	lessorBirthDate: yup.string().required("Campo Obrigatório"),
	lessorEmail: yup.string().notRequired().default(""),
	lessorPhone: yup.string().notRequired().default(""),
	lessorMobilePhone: yup.string().notRequired().default(""),
	lessorTypePerson: yup.string().notRequired().default(""),
	obs: yup.string().required("Campo Obrigatório"),
});

export const formValidationSchemaCancel: yup.SchemaOf<ISimulateEditCancel> = yup.object().shape({
	canceledReason: yup.string().required("Campo Obrigatório"),
	canceledType: yup.string().required("Campo Obrigatório"),
	canceledAt: yup.string().required("Campo Obrigatório"),
});

export const formValidationSchemaGuaranteeData: yup.SchemaOf<IEditProposalGuaranteeData> = yup.object().shape({
	createdFrom: yup.string().required("Campo Obrigatório"),
	employmentRelationShip: yup.string().required("Campo Obrigatório"),
	maritalStatus: yup.string().required("Campo Obrigatório"),
	partnerId: yup.string().required("Campo Obrigatório"),
});
